<template>
  <div ref="containerRef" class="animacion-elegante">
    <!-- Foto principal -->
    <img
      ref="fotoRef"
      src="@/assets/IMG_9601.webp"
      alt="Foto destacada"
      class="foto-elegante-full"
    />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'AnimacionFotoPrincipal',
  setup() {
    const containerRef = ref(null)
    const fotoRef = ref(null)

    const animate = () => {
      gsap.fromTo(
        fotoRef.value,
        {
          y: -120,
          opacity: 0,
          scale: 0.96
        },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 1.6,
          ease: 'bounce.out'
        }
      )
    }

    onMounted(() => {
      const observer = new IntersectionObserver(
        ([entry], obs) => {
          if (entry.isIntersecting) {
            animate()
            obs.unobserve(entry.target)
          }
        },
        {
          threshold: 0.05,      // 🔥 CLAVE: celular friendly
          rootMargin: '0px 0px -50px 0px'
        }
      )

      if (containerRef.value) {
        observer.observe(containerRef.value)
      }
    })

    return {
      containerRef,
      fotoRef
    }
  }
}
</script>

<style scoped>
.animacion-elegante {
  position: relative;
  width: 100%;
  background: #e9ded8;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.foto-elegante-full {
  width: 100%;
  max-width: 100%;
  display: block;
  opacity: 0; /* 👈 importante */
}
</style>
